import { NgModule, enableProdMode } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Routes, RouterModule } from "@angular/router";
import { HttpModule } from "@angular/http";
import { BrowserModule } from "@angular/platform-browser";
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastModule, ToastOptions } from "ng2-toastr";
import { Globals } from "./globals";
import { AppComponent } from "./app.component";
import { LoginComponent } from "./login/login.component";
import { AuthGuard } from "./services/auth/auth.guard";
import { NoCacheInterceptor } from "./no-cache.interceptor";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
export class CustomOption extends ToastOptions {
  animate = "flyRight"; // you can override any options available
  newestOnTop = false;
  showCloseButton = true;
}
const routes: Routes = [
  {
    path: "admin",
    loadChildren: "./backend/backend.module#BackendModule",
    canActivate: [AuthGuard],
  },
  { path: "login", component: LoginComponent },
  { path: "", loadChildren: "./frontend/frontend.module#FrontendModule" },
  { path: "**", redirectTo: "not-found" },
];
enableProdMode();
@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes),
    ToastModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [AppComponent, LoginComponent],
  providers: [
    Globals,
    { provide: ToastOptions, useClass: CustomOption },
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoCacheInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// D:/project_chips/xosotravinh/xosotravinh_angular_client/src/app/app.module.ts